import { EntityType } from 'const';
import * as Models from 'models';
import { getValue } from 'utils/getter';

export function isLayoutRendition(entity: Models.CombinedDocument): entity is Models.Image;
export function isLayoutRendition(entity: Models.CombinedDocumentMap): entity is Models.ImageMap;
export function isLayoutRendition(entity: Models.Relation): entity is Models.RegularRelation<Models.ImageRelationStyles>;
export function isLayoutRendition(entity: Models.RelationMap): entity is Models.RegularRelationMap<Models.ImageRelationStyles>;
export function isLayoutRendition(entity: Models.LayeredRelation): entity is Models.LayeredRegularRelation<Models.ImageRelationStyles>;
export function isLayoutRendition(entity: Models.LayeredRelationMap): entity is Models.LayeredRegularRelationMap<Models.ImageRelationStyles>;
export function isLayoutRendition(entity): boolean {
  return getValue(entity, 'entityType') === EntityType.LAYOUT_RENDITION;
}
